<template lang="pug">
VDialog(
  ref="menu"
  v-model="showDialog"
  max-width="400px"
)
  template(#activator="activatorProps")
    slot(
      name="activator"
      v-bind="activatorProps"
    )
  VCard
    VList(width="auto")
      VListItem
        VListItemTitle.text-wrap {{ i18n.t("ReadingList.AddCommentReadingList") }}
        template(#prepend)
          VBtn(
            :icon="true"
            size="small"
            variant="flat"
            @click="showDialog = false"
          )
            VIcon {{ mdiArrowLeft }}
      VDivider
      ReadingListMenuItem(
        v-for="list in readingLists"
        :key="list.name"
        :list-name="list.name"
        :list-title="list.title"
        :comment-id="commentId"
      )
      VDivider
      VListItem
        ReadingListNew.mt-8(
          variant="outlined"
          density="comfortable"
          :comment-ids="[commentId]"
          :prepend-icon="mdiCreation"
        )
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useI18n } from "vue-i18n";
import { mdiArrowLeft, mdiCreation } from "@mdi/js";
import {
  type ReadingList,
  useReadingListsStore,
} from "~/stores/useReadingListsStore";
import { isDefined } from "~/units/typescriptHelpers";

const readingListsStore = useReadingListsStore();
const i18n = useI18n();
interface Props {
  commentId: number;
}

const props = withDefaults(defineProps<Props>(), {});

const showDialog = ref<boolean>(false);

const readingLists = computed<ReadingList[]>(() =>
  Object.values(readingListsStore.readingLists).filter(isDefined),
);
</script>
